import { useAuthStore } from '@/store/auth-store';
import { sessionScope } from '@/features/auth/session-scope';
import type { CustomFieldEntityType } from './types';

/** Shared with realtime without pulling the editor or SDK into startup. */
export const customFieldLibraryKey = (entity?: CustomFieldEntityType) => {
  const prefix = ['custom-fields', sessionScope(useAuthStore.getState())] as const;
  return entity ? [...prefix, entity] as const : prefix;
};
